// You can write your custom Javascript here
window.addEventListener("load", function(e) {
  var container = document.querySelector(".scrollmenu");
  var middle = container.children[Math.floor((container.children.length - 1) / 2)];
  container.scrollLeft = middle.offsetLeft +
    middle.offsetWidth / 2 - container.offsetWidth / 2;
});


//#region - start of - number counter animation
//const counterAnim = (qSelector, start = 0, end, duration = 1000) => {
// const target = document.querySelector(qSelector);
// let startTimestamp = null;
// const step = (timestamp) => {
//  if (!startTimestamp) startTimestamp = timestamp;
//  const progress = Math.min((timestamp - startTimestamp) / duration, 1);
//  target.innerText = Math.floor(progress * (end - start) + start);
//  if (progress < 1) {
//   window.requestAnimationFrame(step);
//  }
// };
// window.requestAnimationFrame(step);
//};
//#endregion - end of - number counter animation

//document.addEventListener("DOMContentLoaded", () => {
// counterAnim("#count1", 0, 25, 3000); // partenza, fine, velocità 
// counterAnim("#count2", 0, 75, 3000); 
// counterAnim("#count3", 0, 50, 2800);
// counterAnim("#count4", 0, 50, 2800);
// counterAnim("#count5", 0, 75, 3000);
// counterAnim("#count6", 0, 25, 3000);
// counterAnim("#count7", 0, 100, 3500);
// });

// DOM Ready
		
		
			var $el, $ps, $up, totalHeight;
			
			$(".sidebar-box-collection .button-read-more").click(function() {
			
				// IE 7 doesn't even get this far. I didn't feel like dicking with it.
						
				totalHeight = 0
			
				$el = $(this);
				$p  = $el.parent();
				$up = $p.parent();
				$ps = $up.find("p:not('.read-more')");
				
				// measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
				$ps.each(function() {
					totalHeight += $(this).outerHeight();
					// FAIL totalHeight += $(this).css("margin-bottom");
				});
							
				$up
					.css({
						// Set height to prevent instant jumpdown when max height is removed
						"height": $up.height(),
						"max-height": 9999
					})
					.animate({
						"height": totalHeight
					});
				
				// fade out read-more
				$p.fadeOut();
				
				// prevent jump-down
				return false;
					
			});
		
	$(document).ready(function () {
    $(".content").hide();
    $(".show_hide").on("click", function () {
        var txt = $(".content").is(':visible') ? "Lees verder" : 'Lees minder';
        $(".show_hide").text(txt);
        $(".myBtn").toggleClass("open-button");
        $(this).prev('.content').slideToggle(200);
    });
});


//
//$(document).ready(function () {
//    $(".content").hide();
//    $(".show_content").on("click", function () {
//        var txt = $(".content").is(':visible') ? 'Espandi Filtro' : 'Chiudi Filtro';
//        $(".show_content").text(txt);
//        $(".myDiv").toggleClass("not_show yes_show");
//        $(this).prev('.content').slideToggle(200);
//    });
// });


$(document).ready(function(){


  // Pulsante Cane
   $("#cane").click(function(){
   $('#content-filter-perro').addClass('yes_show')
   $('.title-filter-hide').addClass('not_show')
   $('.filter-button-box').addClass('not_show')
  
 });
  
    // Pulsante Gatto
   $("#gatto").click(function(){
   $('#content-filter-gato').addClass('yes_show')
   $('.title-filter-hide').addClass('not_show')
   $('.filter-button-box').addClass('not_show')
  
 });
  
   // Pulsante Back -> Patologie Cane -> Alimentazione
   $(".back-filter").click(function(){
   $('.content-filter').removeClass('yes_show') 
   $('.title-filter-hide').removeClass('not_show')
   $('.filter-button-box').removeClass('not_show')
  
 });

  });

$(document).ready(function(){


  // Pulsante Cane
   $("#dog-hb").click(function(){
   $('#content-filter-perro').addClass('show')
   $('#content-filter-perro').removeClass('hide')
   $('#content-filter-gato').removeClass('show')
   $('#content-filter-gato').addClass('hide')
 });
  
    // Pulsante Gatto
   $("#cat-hb").click(function(){
   $('#content-filter-gato').addClass('show')
   $('#content-filter-gato').removeClass('hide')
   $('#content-filter-perro').removeClass('show')
   $('#content-filter-perro').addClass('hide')
  
 });
  
  });


    // Slider Prodotti Harper Bone 
  // Slider Cane
        $(function() {
            $('#dog-hb').click(function() {
            $(".show").switchClass(
                    ".show", ".hide", '500');
                     
            $(".hide").switchClass(
                    ".hide", ".show", '500');
                     
            return false;
            });
        });

jQuery('#notify-me').click(function() {

jQuery('#notify-me-wrapper').fadeIn();

return false;
} );

  // Pulsante Avvisami quando disponibile
   $("#avvisami").click(function(){
   $('#form-avvisami').toggleClass('not_show','yes_show')
  
 });



// Modal Javascript

  // Get the modal
  
    
    
    
    
    
    
    

var myModal_1 = document.getElementById("myModal_1");
var myModal_second_1 = document.getElementById("myModal_second_1");

// Get the button that opens the modal
var myBtn_1 = document.getElementById("myBtn_1");
var myBtn_second_1 = document.getElementById("myBtn_second_1");

// Get the <span> element that closes the modal
var close_1 = document.getElementById("close_1");
var close_second_1 = document.getElementById("close_second_1");

var overlay_1 = document.getElementById("overlay_1");

// When the user clicks on the button, open the modal 
 myBtn_1.onclick = function() {
  myModal_1.style.display = "block";
  overlay_1.style.display = "block";
}

 myBtn_second_1.onclick = function() {
  myModal_second_1.style.display = "block";
  overlay_1.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
close_1.onclick = function() {  
  myModal_1.style.display = "none";
}
close_second_1.onclick = function() {  
  myModal_second_1.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it


 overlay_1.onclick = function() {
  myModal_1.style.display = "none";
  overlay_1.style.display = "none";
}
 overlay_1.onclick = function() {
  myModal_second_1.style.display = "none";
  overlay_1.style.display = "none";
}


    
    
    
    
    
    
    

var myModal_2 = document.getElementById("myModal_2");
var myModal_second_2 = document.getElementById("myModal_second_2");

// Get the button that opens the modal
var myBtn_2 = document.getElementById("myBtn_2");
var myBtn_second_2 = document.getElementById("myBtn_second_2");

// Get the <span> element that closes the modal
var close_2 = document.getElementById("close_2");
var close_second_2 = document.getElementById("close_second_2");

var overlay_2 = document.getElementById("overlay_2");

// When the user clicks on the button, open the modal 
 myBtn_2.onclick = function() {
  myModal_2.style.display = "block";
  overlay_2.style.display = "block";
}

 myBtn_second_2.onclick = function() {
  myModal_second_2.style.display = "block";
  overlay_2.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
close_2.onclick = function() {  
  myModal_2.style.display = "none";
}
close_second_2.onclick = function() {  
  myModal_second_2.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it


 overlay_2.onclick = function() {
  myModal_2.style.display = "none";
  overlay_2.style.display = "none";
}
 overlay_2.onclick = function() {
  myModal_second_2.style.display = "none";
  overlay_2.style.display = "none";
}


    
    
    
    
    
    
    

var myModal_3 = document.getElementById("myModal_3");
var myModal_second_3 = document.getElementById("myModal_second_3");

// Get the button that opens the modal
var myBtn_3 = document.getElementById("myBtn_3");
var myBtn_second_3 = document.getElementById("myBtn_second_3");

// Get the <span> element that closes the modal
var close_3 = document.getElementById("close_3");
var close_second_3 = document.getElementById("close_second_3");

var overlay_3 = document.getElementById("overlay_3");

// When the user clicks on the button, open the modal 
 myBtn_3.onclick = function() {
  myModal_3.style.display = "block";
  overlay_3.style.display = "block";
}

 myBtn_second_3.onclick = function() {
  myModal_second_3.style.display = "block";
  overlay_3.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
close_3.onclick = function() {  
  myModal_3.style.display = "none";
}
close_second_3.onclick = function() {  
  myModal_second_3.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it


 overlay_3.onclick = function() {
  myModal_3.style.display = "none";
  overlay_3.style.display = "none";
}
 overlay_3.onclick = function() {
  myModal_second_3.style.display = "none";
  overlay_3.style.display = "none";
}


    
    
    
    
    
    
    

var myModal_4 = document.getElementById("myModal_4");
var myModal_second_4 = document.getElementById("myModal_second_4");

// Get the button that opens the modal
var myBtn_4 = document.getElementById("myBtn_4");
var myBtn_second_4 = document.getElementById("myBtn_second_4");

// Get the <span> element that closes the modal
var close_4 = document.getElementById("close_4");
var close_second_4 = document.getElementById("close_second_4");

var overlay_4 = document.getElementById("overlay_4");

// When the user clicks on the button, open the modal 
 myBtn_4.onclick = function() {
  myModal_4.style.display = "block";
  overlay_4.style.display = "block";
}

 myBtn_second_4.onclick = function() {
  myModal_second_4.style.display = "block";
  overlay_4.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
close_4.onclick = function() {  
  myModal_4.style.display = "none";
}
close_second_4.onclick = function() {  
  myModal_second_4.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it


 overlay_4.onclick = function() {
  myModal_4.style.display = "none";
  overlay_4.style.display = "none";
}
 overlay_4.onclick = function() {
  myModal_second_4.style.display = "none";
  overlay_4.style.display = "none";
}


    
    
    
    
    
    
    

var myModal_5 = document.getElementById("myModal_5");
var myModal_second_5 = document.getElementById("myModal_second_5");

// Get the button that opens the modal
var myBtn_5 = document.getElementById("myBtn_5");
var myBtn_second_5 = document.getElementById("myBtn_second_5");

// Get the <span> element that closes the modal
var close_5 = document.getElementById("close_5");
var close_second_5 = document.getElementById("close_second_5");

var overlay_5 = document.getElementById("overlay_5");

// When the user clicks on the button, open the modal 
 myBtn_5.onclick = function() {
  myModal_5.style.display = "block";
  overlay_5.style.display = "block";
}

 myBtn_second_5.onclick = function() {
  myModal_second_5.style.display = "block";
  overlay_5.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
close_5.onclick = function() {  
  myModal_5.style.display = "none";
}
close_second_5.onclick = function() {  
  myModal_second_5.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it


 overlay_5.onclick = function() {
  myModal_5.style.display = "none";
  overlay_5.style.display = "none";
}
 overlay_5.onclick = function() {
  myModal_second_5.style.display = "none";
  overlay_5.style.display = "none";
}


    
    
    
    
    
    
    

var myModal_6 = document.getElementById("myModal_6");
var myModal_second_6 = document.getElementById("myModal_second_6");

// Get the button that opens the modal
var myBtn_6 = document.getElementById("myBtn_6");
var myBtn_second_6 = document.getElementById("myBtn_second_6");

// Get the <span> element that closes the modal
var close_6 = document.getElementById("close_6");
var close_second_6 = document.getElementById("close_second_6");

var overlay_6 = document.getElementById("overlay_6");

// When the user clicks on the button, open the modal 
 myBtn_6.onclick = function() {
  myModal_6.style.display = "block";
  overlay_6.style.display = "block";
}

 myBtn_second_6.onclick = function() {
  myModal_second_6.style.display = "block";
  overlay_6.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
close_6.onclick = function() {  
  myModal_6.style.display = "none";
}
close_second_6.onclick = function() {  
  myModal_second_6.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it


 overlay_6.onclick = function() {
  myModal_6.style.display = "none";
  overlay_6.style.display = "none";
}
 overlay_6.onclick = function() {
  myModal_second_6.style.display = "none";
  overlay_6.style.display = "none";
}




